import {ContentContainer, useMessage} from '@coolcolduk/ui-mui';
import {Refresh as RefreshIcon, Storage} from '@mui/icons-material';
import {Alert, Button, Stack, Typography} from '@mui/material';
import {useState} from 'react';
import {devPopulateData} from '../../../api/callable/devPopulateData';
import {firebaseAuth} from '../../../config/firebase';

export default function AdminDevelopmentPage() {
  const [loading, setLoading] = useState(false);
  const [refreshingToken, setRefreshingToken] = useState(false);
  const {showMessage} = useMessage();

  const handlePopulateData = async () => {
    setLoading(true);
    try {
      const raw = await devPopulateData();
      const results = Array.isArray(raw) ? raw : [raw];
      const summary = results
        .map((r) => {
          const base = `${r.moduleId}: ${r.seedQuestionCount} seed questions, ${r.questionCount} questions, ${r.studyCount} studies`;
          if (r.tradingTradeCount != null) {
            return `${base}, ${r.tradingTradeCount} trading dev trades`;
          }
          return base;
        })
        .join('; ');
      showMessage(`Populated: ${summary}`, 6000, 'success');
    } catch (error) {
      console.error('Populate data error:', error);
      showMessage(`Populate failed: ${error instanceof Error ? error.message : 'Unknown error'}`, 6000, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContentContainer data-testid="admin-development-page">
      <Typography variant="h5" component="h2" sx={{mb: 3}}>
        Development
      </Typography>

      <Typography sx={{mb: 2}}>
        Populate Firestore with test data for the test module and second module. Intended for use with the Firestore
        emulator and local development.
      </Typography>

      <Alert severity="info" sx={{mb: 3}}>
        This creates exam modules &quot;test module&quot; and &quot;second module&quot; with the same seed questions,
        questions, and studies. Running again will fail if the modules already exist.
      </Alert>

      <Stack direction="row" spacing={2}>
        <Button
          variant="contained"
          startIcon={<Storage />}
          onClick={handlePopulateData}
          disabled={loading || refreshingToken}
          sx={{textTransform: 'none'}}
        >
          {loading ? 'Populating…' : 'Populate data'}
        </Button>

        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          disabled={refreshingToken}
          sx={{textTransform: 'none'}}
          onClick={async () => {
            const currentUser = firebaseAuth.currentUser;
            if (!currentUser) {
              showMessage('No authenticated user to refresh token for.', 4000, 'error');
              return;
            }
            setRefreshingToken(true);
            try {
              await currentUser.getIdToken(true);
              showMessage('Auth token refreshed.', 4000, 'success');
            } catch (error) {
              console.error('Token refresh error:', error);
              showMessage(
                `Token refresh failed: ${error instanceof Error ? error.message : 'Unknown error'}`,
                6000,
                'error',
              );
            } finally {
              setRefreshingToken(false);
            }
          }}
        >
          {refreshingToken ? 'Refreshing token…' : 'Refresh auth token'}
        </Button>
      </Stack>
    </ContentContainer>
  );
}
